import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentManagerService {
  private subject = new Subject<any>();
  private currentEnvironment: string;

  constructor() {
    const lsValue = localStorage.getItem('enviroment');
    if (lsValue && (lsValue === 'production' || lsValue === 'stage')) {
      this.setCurrentEnvironment(lsValue);
    } else {
      this.setCurrentEnvironment('production');
    }
  }

  public getEnvironmentChangedListener(): Observable<any> {
    return this.subject.asObservable();
  }

  public switchEnvironment(current: string) {
    if (current === 'stage') {
      return this.setCurrentEnvironment('production');
    } else if (current === 'production') {
      return this.setCurrentEnvironment('stage');
    }
  }

  public getCurrentEnvironment() {
    return this.currentEnvironment;
  }

  public getOtherEnvironment() {
    return this.currentEnvironment === 'stage' ? 'production' : 'stage';
  }

  private setCurrentEnvironment(current: string) {
    this.currentEnvironment = current;
    this.subject.next(this.currentEnvironment);
    localStorage.setItem('enviroment', this.currentEnvironment);
    return this.currentEnvironment;
  }
}
